import React from 'react';

const InBodyScanConsent = () => {
    return (
        <>
            <h3>Súhlas so spracúvaním osobných údajov osobitnej kategórie – InBody</h3>
            <h4>Meranie telesného zloženia InBody 270s</h4>
            <p className={'my-3'}>
                Prevádzkovateľ: rovenski s. r. o., Rovenská 668/2, 905 01 Senica, IČO: 56703236<br/>
                (ďalej len „Prevádzkovateľ“)
            </p>
            <p className={'my-3'}>Tento dokument je potrebné vyplniť a odsúhlasiť pred prvým meraním InBody. Bez
                udelenia súhlasu nie je možné meranie vykonať.</p>

            <h4>1. ČO SA MERANÍM ZISŤUJE</h4>
            <p className={'my-3'}>Prístroj InBody 270s pomocou bioelektrickej impedančnej analýzy (slabý, neškodný
                elektrický prúd prechádzajúci telom) meria najmä: telesnú hmotnosť, percento telesného tuku, množstvo
                svalovej hmoty, množstvo vody v tele, viscerálny (útrobný) tuk, bazálny metabolizmus a segmentálnu
                analýzu jednotlivých častí tela.</p>

            <h4>2. AKÉ ÚDAJE SPRACÚVAME</h4>
            <p className={'my-3'}>V súvislosti s meraním spracúvame: meno a priezvisko, emailovú adresu, dátum
                narodenia alebo vek, pohlavie, výšku, a namerané hodnoty telesného zloženia uvedené v bode 1. Tieto
                údaje sú vzhľadom na svoju povahu údajmi o zdravotnom stave v zmysle čl. 9 GDPR.</p>

            <h4>3. PRÁVNY ZÁKLAD A ÚČEL SPRACÚVANIA</h4>
            <p className={'my-3'}>Právnym základom spracúvania je Váš výslovný súhlas podľa čl. 6 ods. 1 písm. a) a
                čl. 9 ods. 2 písm. a) GDPR. Údaje spracúvame výlučne na účel vykonania merania, poskytnutia výsledkov
                a prípadnej konzultácie, ako aj na porovnanie výsledkov pri opakovaných meraniach v rámci zakúpeného
                balíka.</p>

            <h4>4. KDE SÚ ÚDAJE ULOŽENÉ – PRENOS DO TRETEJ KRAJINY</h4>
            <p className={'my-3'}>Namerané výsledky sú ukladané na cloudovom úložisku prevádzkovanom spoločnosťou
                InBody Co., Ltd., so sídlom v Kórejskej republike, ktorá pre Prevádzkovateľa vystupuje ako
                sprostredkovateľ spracúvania. Tento prenos je možný na základe rozhodnutia Európskej komisie o
                primeranosti ochrany osobných údajov v Kórejskej republike zo dňa 17. 12. 2021, ktoré prenos osobných
                údajov do tejto krajiny umožňuje bez potreby ďalších zmluvných záruk.</p>

            <h4>5. DOBA UCHOVÁVANIA</h4>
            <p className={'my-3'}>Namerané údaje uchovávame po dobu 24 mesiacov od posledného merania, prípadne po
                dobu trvania Vášho aktívne zakúpeného balíka meraní predĺženú o čas potrebný na porovnanie výsledkov,
                najviac však 3 roky od posledného merania. Po uplynutí tejto doby budú údaje vymazané, pokiaľ
                nepožiadate o skoršie vymazanie.</p>

            <h4>6. VAŠE PRÁVA</h4>
            <p className={'my-3'}>Súhlas je dobrovoľný a môžete ho kedykoľvek odvolať, a to e-mailom na
                info@formafitness.sk, bez uvedenia dôvodu a bez vplyvu na zákonnosť spracúvania pred jeho odvolaním.
                Odvolanie súhlasu znamená, že Vám už nebudeme môcť poskytovať službu merania InBody. Máte tiež právo
                na prístup k údajom, ich opravu, vymazanie, obmedzenie spracúvania a prenosnosť – bližšie v
                Informáciách o spracúvaní osobných údajov. Sťažnosť môžete podať na Úrad na ochranu osobných údajov
                SR (www.dataprotection.gov.sk).</p>

            <h4>7. CHARAKTER VÝSLEDKOV – DÔLEŽITÉ UPOZORNENIE</h4>
            <p className={'my-3'}>Meranie InBody a jeho výsledky majú výhradne informatívny a orientačný charakter.
                Nejde o lekárske vyšetrenie, diagnostiku ani zdravotný posudok a výsledky nenahrádzajú konzultáciu s
                lekárom. Prevádzkovateľ nezodpovedá za zdravotné, výživové ani tréningové rozhodnutia, ktoré Klient
                urobí na základe výsledkov merania.</p>

            <h4>8. VYHLÁSENIE O ZDRAVOTNOM STAVE (KONTRAINDIKÁCIE)</h4>
            <p className={'my-3'}>Meranie využíva slabý elektrický prúd, a preto ho z bezpečnostných dôvodov nemôžu
                absolvovať:
                <ul>
                    <li>tehotné ženy,</li>
                    <li>osoby s kardiostimulátorom alebo iným implantovaným elektronickým zdravotníckym prístrojom
                        (napr. defibrilátor, inzulínová pumpa, neurostimulátor).
                    </li>
                </ul>
            </p>
            <p className={'my-3'}>Klient svojím podpisom potvrdzuje:
                <ul>
                    <li>☐ Nie som tehotná.</li>
                    <li>☐ Nemám implantovaný kardiostimulátor ani iný implantovaný elektronický zdravotnícky
                        prístroj.
                    </li>
                    <li>☐ Beriem na vedomie, že faktory ako menštruácia, konzumácia jedla/tekutín alebo cvičenie
                        tesne pred meraním môžu ovplyvniť presnosť (nie bezpečnosť) výsledkov.
                    </li>
                    <li>☐ Boli mi zrozumiteľne vysvetlené informácie uvedené v bodoch 1 až 7 tohto dokumentu a v
                        plnom rozsahu s nimi súhlasím.
                    </li>
                </ul>
            </p>

            <h4>9. SÚHLAS ZÁKONNÉHO ZÁSTUPCU (len ak je Klient mladší ako 18 rokov)</h4>
            <p className={'my-3'}>
                Meranie u osoby mladšej ako 18 rokov je možné vykonať len s výslovným súhlasom zákonného zástupcu a v
                jeho prítomnosti alebo na základe ním podpísaného tohto dokumentu.<br/><br/>
                Meno a priezvisko zákonného zástupcu: .......................................................<br/><br/>
                Vzťah k maloletému: .......................................................
            </p>

            <h4>10. ÚDAJE KLIENTA A PODPIS</h4>
            <p className={'my-3'}>
                Meno a priezvisko: .......................................................<br/><br/>
                Dátum narodenia / vek: .......................................................<br/><br/>
                Miesto / Dátum: .......................................................<br/><br/>
                Podpis Klienta (prípadne zákonného zástupcu): .......................................................
            </p>
        </>
    );
}

export default InBodyScanConsent;
